export const GLOBAL_LABELS = {
    APP_TITLE: 'EVA',
};